import React from 'react';
import cv from '../CV/MOHAMMAD I NUSIR.pdf';
function About() {
  return (
    <section id="about" className="section">
      <h2>About Me</h2>
      <p>
      Hello! My name is Mohammad I Nusir, a web developer and machine learning lover with a one-of-a-kind passion for music and programming. After 5 years spent working in the tech and electricity industries, I’ve worked on plenty of projects playing with different things which have trained me and brought me closer to my passion!      </p>
      <p>
      This journey started with a degree in Computer Science at Al-Albayt University. Ever since then, I have continued learning and changing according to the changing world of technology. Specifically, I’m interested in AI and web development and how we can build machine learning models into web-based applications.      </p>
      <p>
      Other than coding, I am an avid composer. I always consider music an essential element of anyone’s life and the music I listen to definitely helps my technical work by keeping creative thinking and attention to details on the same level. Several original compositions have been released by me.
      </p>
      {/* <p>
      I loved languages, so I became a book translator. I speak fluently Arabic and English and have translated many works of fiction and non-fiction. This experience has helped me sharpen my communication skills and made me see what a difference clear, effective communication makes between natural and programming languages.
      </p> */}
      <p>
      I’m all about the new, and the more challenging it is, the better! You can have a look at my portfolio, and if you want to collaborate feel free to get in touch!
      </p>
      <div style={{textAlign:"center"}}>
        <a className='textColor' href={cv}  target="_blank" rel="noopener noreferrer"> <i className="fa fa-download"></i> CV</a>
      </div>
    </section>
  );
}

export default About;